import { Type } from 'class-transformer';
import { Model } from './model';
import { OutreachRule } from './outreach_rule';

export class OutreachGroup extends Model {
  id: string;

  name: string;

  call_window_start: string;

  call_window_end: string;

  call_timezone: string;

  defer_to_assignee_email_sender: boolean;

  execution_time: string;

  email_sender_id: string | null;

  grace_period_after_outbound: number;

  grace_period_after_inbound: number;

  is_enabled: boolean;

  max_weekly_emails: number;

  max_weekly_calls: number;

  test_mode: boolean;

  test_email_recipient: string | null;

  test_phone_number_recipient: string | null;

  @Type(() => StrategyPrompt)
  current_prompt: StrategyPrompt | undefined;

  @Type(() => StrategyPrompt)
  prompts: StrategyPrompt[];

  @Type(() => OutreachRule)
  rules: OutreachRule[];
}

export class StrategyPrompt extends Model {
  id: string;

  content: string;
}
